import ReactOnRails from 'react-on-rails';

import HealingExperience from '../bundles/HealingExperience/components/HealingExperience';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  HealingExperience,
});
